import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import moment from "moment";
import { createList, getCampaigns, addEmail, verifyEmail, getEmails, getLists, getList, deleteList, updateList, downloadCampaignResults, downloadListContacts, deleteAllListContacts, getSegmentData, updateEmailSubscribe, updateSegments, getSegmentList, getCampaignStatistics, createCampaign, cancelCampaign, updateCampaign } from "../../api/marketing-api";
import { CLEAR_CURRENT_LIST, SET_MARKETING_CAMPAIGNS, SET_AUTOMATION_CRITERIA, SET_CURRENT_EMAIL_ID, SET_MARKETING_EMAILS, SET_LISTS, SET_CURRENT_LIST, UPDATE_MARKETING_EMAILS, SET_SEGMENT_LIST, SET_SEGMENT_DATA, SET_EMAIL_SUBSCRIBED_ALL, SET_EMAIL_SUBSCRIBED_SEGMENT, SET_CAMPAIGN_STATISTICS, SET_MARKETING_CAMPAIGN, SET_SEGMENTS_TRANSLATION_MAP } from "./marketing-mutations";
import Err from "@Broker/@Routes/error";
import { normalize } from "normalizr";
import { campaignSchema, emailSchema, listSchema } from "./marketing-schema";
import { showToast } from "@Shared/utils/constants";
import Amplitude from "@Shared/utils/amplitude";
export const LOAD_LISTS = "LOAD_LISTS";
export const LOAD_CURRENT_LIST = "LOAD_CURRENT_LIST";
export const CREATE_NEW_LIST = "CREATE_NEW_LIST";
export const RESET_CURRENT_LIST = "RESET_CURRENT_LIST";
export const LOAD_MARKETING_CAMPAIGNS = "LOAD_MARKETING_CAMPAIGNS";
export const LOAD_MARKETING_EMAILS = "LOAD_MARKETING_EMAILS";
export const CREATE_MARKETING_EMAIL = "CREATE_MARKETING_EMAIL";
export const VERIFY_MARKETING_EMAIL = "VERIFY_MARKETING_EMAIL";
export const UPDATE_LIST = "UPDATE_LIST";
export const DOWNLOAD_CAMPAIGN_RESULTS = "DOWNLOAD_CAMPAIGN_RESULTS";
export const DELETE_CURRENT_LIST = "DELETE_CURRENT_LIST";
export const EXPORT_LIST_CONTACTS = "EXPORT_LIST_CONTACTS";
export const DELETE_ALL_LIST_CONTACTS = "DELETE_ALL_LIST_CONTACTS";
export const UPDATE_SEGMENTS = "UPDATE_SEGMENTS";
export const LOAD_SEGMENT_DATA = "LOAD_SEGMENT_DATA";
export const LOAD_SEGMENT_LIST = "LOAD_SEGMENT_LIST";
export const UPDATE_EMAIL_SUBSCRIBED_ALL = "UPDATE_EMAIL_SUBSCRIBED_ALL";
export const UPDATE_EMAIL_SUBSCRIBED_SEGMENT = "UPDATE_EMAIL_SUBSCRIBED_SEGMENT";
export const LOAD_CAMPAIGN_STATISTICS = "LOAD_CAMPAIGN_STATISTICS";
export const CREATE_MARKETING_CAMPAIGN = "CREATE_MARKETING_CAMPAIGN";
export const CANCEL_CAMPAIGN = "CANCEL_CAMPAIGN";
export const UPDATE_CURRENT_CAMPAIGN = "UPDATE_CURRENT_CAMPAIGN";
export const UPDATE_CAMPAIGN = "UPDATE_CAMPAIGN";
export const UPDATE_CURRENT_LIST = "UPDATE_CURRENT_LIST";
const actions = {
  [CREATE_NEW_LIST]: async (context, details = null) => {
    try {
      const listToUse = details || context.state.currentList;
      const {
        name,
        description,
        address,
        applications,
        clientProfiles,
        referrerList,
        imported,
        system = false,
        agentsToImportFrom,
        importedList = [],
        csvArray,
        withCoapps,
        interval = null
      } = listToUse;
      const {
        listId
      } = await createList({
        name,
        description,
        address,
        applications,
        clientProfiles,
        referrerList,
        imported,
        agentsToImportFrom,
        importedList,
        csvArray,
        system,
        withCoapps,
        interval
      });
      const listToAdd = {
        listId,
        name,
        description,
        emailCount: importedList.length
      };
      const {
        lists
      } = context.state;
      context.commit(SET_LISTS, {
        byId: _objectSpread(_objectSpread({}, lists.byId), {}, {
          [listId]: listToAdd
        }),
        allIds: [...lists.allIds, listId]
      });
      Amplitude.logEvent("Lists - created");
      return {
        listId
      };
    } catch (e) {
      Err.handle(e);
    }
  },
  [UPDATE_CURRENT_LIST]: async (context, list) => {
    context.commit(SET_CURRENT_LIST, list);
  },
  [UPDATE_LIST]: async (context, {
    listId,
    data = {}
  }) => {
    try {
      const {
        name,
        description,
        address,
        applications,
        clientProfiles,
        referrerList,
        withCoapps,
        imported,
        agentsToImportFrom,
        importedList,
        csvArray,
        interval
      } = data;
      await updateList({
        name,
        description,
        address,
        applications,
        clientProfiles,
        referrerList,
        withCoapps,
        imported,
        agentsToImportFrom,
        importedList,
        csvArray,
        interval
      }, listId);
    } catch (e) {
      Err.handle(e);
    }
  },
  [DELETE_CURRENT_LIST]: async (context, listId) => {
    try {
      await deleteList(listId);
      showToast("success", "listDeleted");
    } catch (e) {
      Err.handle(e);
      throw e;
    }
  },
  [EXPORT_LIST_CONTACTS]: async (context, {
    listId,
    segmentId = null
  }) => {
    try {
      const {
        url
      } = await downloadListContacts(listId, segmentId);
      const newWindow = window.open(url, "_self");
      if (newWindow) newWindow.location.href = url;
    } catch (e) {
      showToast("error", "cannotDownloadFile");
      Amplitude.logHandledError(e, {}, "cannotDownloadFile");
    }
  },
  [DELETE_ALL_LIST_CONTACTS]: async (context, listId) => {
    try {
      await deleteAllListContacts(listId);
      showToast("success", "allContactsDeleted");
    } catch (e) {
      Err.handle(e);
      throw e;
    }
  },
  [RESET_CURRENT_LIST]: context => {
    context.commit(CLEAR_CURRENT_LIST);
  },
  [LOAD_MARKETING_CAMPAIGNS]: async (context, {
    all = true,
    type = "scheduled"
  }) => {
    try {
      const {
        campaigns,
        predefinedCriteria
      } = await getCampaigns(all, type);
      const {
        entities,
        result
      } = normalize(campaigns, [campaignSchema]);
      const {
        add = {
          campaignId: "add"
        }
      } = context.state.campaigns.byId;
      context.commit(SET_MARKETING_CAMPAIGNS, {
        byId: _objectSpread(_objectSpread({}, entities.campaigns), {}, {
          add
        }) || {},
        allIds: result
      });
      if (predefinedCriteria) {
        context.commit(SET_AUTOMATION_CRITERIA, {
          criteria: predefinedCriteria
        });
      }
    } catch (e) {
      Err.handle(e);
    }
  },
  [CREATE_MARKETING_EMAIL]: async context => {
    try {
      const {
        emailId
      } = await addEmail({
        email: context.state.currentEmail.email
      });
      context.commit(SET_CURRENT_EMAIL_ID, {
        emailId: emailId.toString()
      });
      context.commit(UPDATE_MARKETING_EMAILS, {
        emailId: emailId.toString(),
        email: context.state.currentEmail
      });
      return {
        emailId
      };
    } catch (e) {
      Err.handle(e);
      throw e;
    }
  },
  [VERIFY_MARKETING_EMAIL]: async (context, {
    forceEmailToVerify
  }) => {
    try {
      const emailToUse = forceEmailToVerify || context.state.currentEmail;
      const {
        emailId
      } = emailToUse;
      const {
        verified
      } = await verifyEmail(emailId);
      const newEmailData = _objectSpread(_objectSpread({}, emailToUse), {}, {
        verified
      });
      context.commit(UPDATE_MARKETING_EMAILS, {
        emailId: emailId.toString(),
        email: newEmailData
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [LOAD_MARKETING_EMAILS]: async context => {
    try {
      const {
        emails
      } = await getEmails();
      const {
        entities,
        result
      } = normalize(emails, [emailSchema]);
      context.commit(SET_MARKETING_EMAILS, {
        byId: entities.emails || {},
        allIds: result
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [LOAD_LISTS]: async context => {
    try {
      const {
        lists
      } = await getLists();
      const {
        entities,
        result
      } = normalize(lists, [listSchema]);
      context.commit(SET_LISTS, {
        byId: entities.lists || {},
        allIds: result
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [LOAD_CURRENT_LIST]: async (context, {
    listId,
    offset = 0,
    limit = 10,
    orderBy = "updatedAt",
    orderType = "DESC",
    searchString = ""
  }) => {
    try {
      const details = await getList(listId, offset, limit, orderBy, orderType, searchString);
      details.offset = offset;
      details.limit = limit;
      details.searchString = searchString;
      context.commit(SET_CURRENT_LIST, details);
    } catch (e) {
      Err.handle(e);
    }
  },
  [LOAD_SEGMENT_LIST]: async (context, {
    listId,
    segmentId,
    offset = 0,
    limit = 10,
    orderBy = "updatedAt",
    orderType = "DESC",
    searchString = ""
  }) => {
    try {
      const details = await getSegmentList(listId, segmentId, offset, limit, orderBy, orderType, searchString);
      const {
        segmentedList
      } = details;
      segmentedList.offset = offset;
      segmentedList.limit = limit;
      segmentedList.searchString = searchString;
      const list = {
        [segmentedList.segmentId]: segmentedList
      };
      context.commit(SET_SEGMENT_LIST, list);
    } catch (e) {
      Err.handle(e);
    }
  },
  [DOWNLOAD_CAMPAIGN_RESULTS]: async (context, {
    campaignId
  }) => {
    try {
      const newWindow = window.open();
      const res = await downloadCampaignResults(campaignId);
      if (newWindow) newWindow.location.href = res.url;
    } catch (e) {
      showToast("error", "cannotDownloadFile");
      Amplitude.logHandledError(e, {}, "cannotDownloadFile");
    }
  },
  [UPDATE_EMAIL_SUBSCRIBED_ALL]: async (context, {
    suppressed,
    listId,
    emailId
  }) => {
    try {
      await updateEmailSubscribe(suppressed, listId, emailId);
      context.commit(SET_EMAIL_SUBSCRIBED_ALL, {
        suppressed,
        emailId
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [UPDATE_EMAIL_SUBSCRIBED_SEGMENT]: async (context, {
    suppressed,
    listId,
    emailId,
    segmentId
  }) => {
    try {
      await updateEmailSubscribe(suppressed, listId, emailId);
      context.commit(SET_EMAIL_SUBSCRIBED_SEGMENT, {
        suppressed,
        emailId,
        segmentId
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [UPDATE_SEGMENTS]: async (context, {
    segments,
    listId
  }) => {
    const oldSegments = context.state.currentList;
    try {
      context.commit(SET_CURRENT_LIST, segments);
      await updateSegments(segments, listId);
    } catch (e) {
      context.commit(SET_CURRENT_LIST, oldSegments);
      Err.handle(e);
    }
  },
  [LOAD_SEGMENT_DATA]: async context => {
    try {
      const {
        segments,
        translationMap
      } = await getSegmentData();
      context.commit(SET_SEGMENT_DATA, segments);
      context.commit(SET_SEGMENTS_TRANSLATION_MAP, {
        translationMap
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [LOAD_CAMPAIGN_STATISTICS]: async (context, campaignId) => {
    const {
      statistics
    } = await getCampaignStatistics(campaignId);
    context.commit(SET_CAMPAIGN_STATISTICS, {
      campaignId,
      statistics
    });
  },
  [CREATE_MARKETING_CAMPAIGN]: async (context, campaignDetails) => {
    const campaign = _objectSpread(_objectSpread({}, campaignDetails), {}, {
      type: "scheduled"
    });
    const {
      campaignId
    } = await createCampaign(campaign);
    context.commit(SET_MARKETING_CAMPAIGN, _objectSpread(_objectSpread({}, campaign), {}, {
      campaignId,
      status: "active"
    }));
  },
  [CANCEL_CAMPAIGN]: async (context, campaignDetails) => {
    await cancelCampaign(campaignDetails.campaignId);
    context.commit(SET_MARKETING_CAMPAIGN, _objectSpread(_objectSpread({}, campaignDetails), {}, {
      updatedAt: moment().toISOString(),
      status: "cancelled"
    }));
  },
  [UPDATE_CURRENT_CAMPAIGN]: async (context, campaignDetails) => {
    context.commit(SET_MARKETING_CAMPAIGN, campaignDetails);
  },
  [UPDATE_CAMPAIGN]: async (context, campaignDetails) => {
    await updateCampaign(campaignDetails.campaignId, _objectSpread(_objectSpread({}, campaignDetails), {}, {
      status: null
    }));
    context.commit(SET_MARKETING_CAMPAIGN, _objectSpread(_objectSpread({}, campaignDetails), {}, {
      updatedAt: moment().toISOString()
    }));
  }
};
export default actions;